import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, delay, mergeMap, switchMap } from "rxjs/operators";
import { addNotification, closeModalAction } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, FOLDER_CREATE_MODAL, NotificationTypeEnum } from "../../../actions/ui/types";
import { UPLOAD_FILE_FOLDER_FAILURE, UPLOAD_FILE_FOLDER_REQUEST } from "../../../actions/types";
import { setCurrentFolderPath, uploadFileFolderAction } from "../../../actions";
import { BACKEND_SYNC_DELAY } from "../../../constants";
export var uploadFileFolderEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(UPLOAD_FILE_FOLDER_REQUEST), switchMap(function(action) {
        return from(api.reportsCenterService.uploadReport(action.payload.uploadReportInput).pipe(delay(BACKEND_SYNC_DELAY), mergeMap(function(response) {
            var _action_payload_uploadReportInput, _action_payload;
            return of(uploadFileFolderAction.success(response), closeModalAction({
                type: FOLDER_CREATE_MODAL
            }), setCurrentFolderPath((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_uploadReportInput = _action_payload.uploadReportInput) === null || _action_payload_uploadReportInput === void 0 ? void 0 : _action_payload_uploadReportInput.objectKey));
        }), catchError(function(err) {
            return of(uploadFileFolderAction.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: UPLOAD_FILE_FOLDER_FAILURE,
                body: "upload_file_folder_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default uploadFileFolderEpic;

//# sourceMappingURL=index.js.map